export const gaEvent = (dataLayer: Record<string, unknown>) => {
  window.dataLayer.push(dataLayer)
}
